import React, { useState, useEffect } from 'react';

function App() {

  const [sessions, setSessions] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      await fetch('https://internalapi.dreamworld.com.au/inparkdisplaysapi/climbsession/availability')
        .then((res) => res.json())
        .then((res) => setSessions(res))
        .catch((e) => console.error(e))
    };
  
    const interval = setInterval(() => {
      fetchData()
    }, 10000);

    fetchData();

    return () => clearInterval(interval)
  }, []);

  function currentTime(dt, time) {
    let text = "Next"
    let date = new Date()
    let Year = date.getFullYear()
    let nextDate = new Date(Year+" "+dt+" "+ time)
    if (nextDate <= date) { text = "Current"}
    return(text)
  }

  return (
    <section className="flex flex-row bg-black">
{/* Left Side */}
      <div className="basis-1/4 bg-primary truncate relative flex items-center justify-center">
        <img src="./experience.png" className="top-0 absolute" alt="experience" />
          <div className="flex flex-col text-secondary text-center">
            <div className="text-4xl mb-3">
              {sessions.nextClimbTime && currentTime(sessions.nextClimbDate, sessions.nextClimbTime)} Climb Departs
            </div>
            <div className="text-5xl my-4">{sessions.nextClimbTime}</div>
            <div className="text-5xl">{sessions.nextClimbDate}</div>
          </div>
        <img src="./climb.png" className="bottom-0 absolute" alt="climb" />
      </div>
{/* Right Side */}
      <div className="basis-3/4 bg-secondary">
        <h1 className="text-white w-full text-center text-4xl pt-5">SkyPoint Climb Session Times</h1>
        <div className="flex flex-row w-full px-16 pt-8">
          <div className="w-full flex flex-col flex-wrap data text-white text-xl">
          {sessions.data && sessions.data.map((session, index) => {
            return (
              <div className="m-4 w-6/12" key={session.day+"-"+index}>
                <h4 className="text-primary text-3xl mb-3">{session.day}</h4>
                {session.event.map((e, i) => {
                  return(
                    <div className="flex flex-row pl-10 py-1" key={"event_"+i}>
                      <div className="mx-4 min-w-28 text-center day text-primary">{e.type}</div>
                      <div className="mx-4 min-w-28">{e.time}</div>
                      {e.remainingTickets === "0" && (
                        <div className="mx-4 w-52 text-right text-primary">Sold Out</div>
                      )}
                      {e.remainingTickets !== "0" && (
                        <div className="mx-4 w-52 text-right">Remaining Tickets {e.remainingTickets}</div>
                      )
                      }
                    </div>
                  )
                }
                )}
              </div>
            )
          })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default App;